namespace Matrix.Data {
    export interface SecurityMergeRow {
        SourceCode?: string;
        SourceSecurityId?: string;
        SecurityId?: number;
        SecurityCode?: string;
        RuleName?: string;
        RuleNameProposed?: string;
        SecurityIdProposed?: number;
        SecurityIdProposedWhen?: string;
        ReviewedBy?: string;
        ReviewedWhen?: string;
        StaleMatch?: boolean;
        DealParentCode?: string;
        Name?: string;
        SecurityTypeCode?: string;
        LocalCurrencyCode?: string;
        ExposureMultiplier?: number;
        AssociatedAccountCode?: string;
        Sedol?: string;
        RIC?: string;
        Isin?: string;
        Cusip?: string;
        Figi?: string;
        Ticker?: string;
        InternalSecurityCode?: string;
        Issuer?: string;
        IssuerCode?: string;
        CouponRate?: number;
        MaturityDate?: string;
        SpLtRating?: string;
        SpStRating?: string;
        MoodysLtRating?: string;
        MoodysStRating?: string;
        FitchLtRating?: string;
        FitchStRating?: string;
        InternalLtRating?: string;
        InternalStRating?: string;
        CountryOfIssueCode?: string;
        CountryOfRiskCode?: string;
        CurrencyOfRiskCode?: string;
        TradeDate?: string;
        EffectiveDate?: string;
        BrokerCode?: string;
        Strategy?: string;
        OptionStyle?: string;
        ExerciseStyle?: string;
        PutOrCall?: string;
        StrikePrice?: number;
        StrikeCurrency?: string;
        Premium?: number;
        PremiumCcy?: string;
        PayOrRec?: string;
        FixedOrFloat?: string;
        FloatIndex?: string;
        InflationIndexLag?: string;
        InterestTerm?: string;
        Spread?: number;
        AllIn?: number;
        InterestCcy?: string;
        PaymentFrequency?: string;
        PaymentBusDayConvention?: string;
        PaymentCalendar?: string;
        FirstPaymentDate?: string;
        DayCountBasis?: string;
        ResetFrequency?: string;
        ResetBusDayConvention?: string;
        ResetCalendar?: string;
        ClearerReference?: string;
        RedCode?: string;
        CreditEvents?: string;
        Guarantor?: string;
        GicsSector?: number;
        GicsIndustryGroup?: number;
        GicsIndustry?: number;
        GicsSubIndustry?: number;
        BorrowerCode?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        MatchedToSourceCode?: string;
        MatchedToSourceSecurityId?: string;
        MatchedBy?: string;
        MatchedWhen?: string;
        RepairedBy?: string;
        RepairedWhen?: string;
        SMPrimarySecurity?: boolean;
        SMPrimarySecurityOverriden?: boolean;
    }

    export namespace SecurityMergeRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'SourceCode';
        export const localTextPrefix = 'Data.SecurityMerge';
        export const deletePermission = 'DataAdmin:SecurityMerge';
        export const insertPermission = 'DataAdmin:SecurityMerge';
        export const readPermission = 'Read:SecurityMerge';
        export const updatePermission = 'DataAdmin:SecurityMerge';

        export declare const enum Fields {
            SourceCode = "SourceCode",
            SourceSecurityId = "SourceSecurityId",
            SecurityId = "SecurityId",
            SecurityCode = "SecurityCode",
            RuleName = "RuleName",
            RuleNameProposed = "RuleNameProposed",
            SecurityIdProposed = "SecurityIdProposed",
            SecurityIdProposedWhen = "SecurityIdProposedWhen",
            ReviewedBy = "ReviewedBy",
            ReviewedWhen = "ReviewedWhen",
            StaleMatch = "StaleMatch",
            DealParentCode = "DealParentCode",
            Name = "Name",
            SecurityTypeCode = "SecurityTypeCode",
            LocalCurrencyCode = "LocalCurrencyCode",
            ExposureMultiplier = "ExposureMultiplier",
            AssociatedAccountCode = "AssociatedAccountCode",
            Sedol = "Sedol",
            RIC = "RIC",
            Isin = "Isin",
            Cusip = "Cusip",
            Figi = "Figi",
            Ticker = "Ticker",
            InternalSecurityCode = "InternalSecurityCode",
            Issuer = "Issuer",
            IssuerCode = "IssuerCode",
            CouponRate = "CouponRate",
            MaturityDate = "MaturityDate",
            SpLtRating = "SpLtRating",
            SpStRating = "SpStRating",
            MoodysLtRating = "MoodysLtRating",
            MoodysStRating = "MoodysStRating",
            FitchLtRating = "FitchLtRating",
            FitchStRating = "FitchStRating",
            InternalLtRating = "InternalLtRating",
            InternalStRating = "InternalStRating",
            CountryOfIssueCode = "CountryOfIssueCode",
            CountryOfRiskCode = "CountryOfRiskCode",
            CurrencyOfRiskCode = "CurrencyOfRiskCode",
            TradeDate = "TradeDate",
            EffectiveDate = "EffectiveDate",
            BrokerCode = "BrokerCode",
            Strategy = "Strategy",
            OptionStyle = "OptionStyle",
            ExerciseStyle = "ExerciseStyle",
            PutOrCall = "PutOrCall",
            StrikePrice = "StrikePrice",
            StrikeCurrency = "StrikeCurrency",
            Premium = "Premium",
            PremiumCcy = "PremiumCcy",
            PayOrRec = "PayOrRec",
            FixedOrFloat = "FixedOrFloat",
            FloatIndex = "FloatIndex",
            InflationIndexLag = "InflationIndexLag",
            InterestTerm = "InterestTerm",
            Spread = "Spread",
            AllIn = "AllIn",
            InterestCcy = "InterestCcy",
            PaymentFrequency = "PaymentFrequency",
            PaymentBusDayConvention = "PaymentBusDayConvention",
            PaymentCalendar = "PaymentCalendar",
            FirstPaymentDate = "FirstPaymentDate",
            DayCountBasis = "DayCountBasis",
            ResetFrequency = "ResetFrequency",
            ResetBusDayConvention = "ResetBusDayConvention",
            ResetCalendar = "ResetCalendar",
            ClearerReference = "ClearerReference",
            RedCode = "RedCode",
            CreditEvents = "CreditEvents",
            Guarantor = "Guarantor",
            GicsSector = "GicsSector",
            GicsIndustryGroup = "GicsIndustryGroup",
            GicsIndustry = "GicsIndustry",
            GicsSubIndustry = "GicsSubIndustry",
            BorrowerCode = "BorrowerCode",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            MatchedToSourceCode = "MatchedToSourceCode",
            MatchedToSourceSecurityId = "MatchedToSourceSecurityId",
            MatchedBy = "MatchedBy",
            MatchedWhen = "MatchedWhen",
            RepairedBy = "RepairedBy",
            RepairedWhen = "RepairedWhen",
            SMPrimarySecurity = "SMPrimarySecurity",
            SMPrimarySecurityOverriden = "SMPrimarySecurityOverriden"
        }
    }
}
